import { render, staticRenderFns } from "./ResumeDisclaimer.vue?vue&type=template&id=0d4b818a&scoped=true&"
import script from "./ResumeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ResumeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ResumeDisclaimer.vue?vue&type=style&index=0&id=0d4b818a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b818a",
  null
  
)

export default component.exports